var $5d0ff97fe4cea552$exports = {};
$5d0ff97fe4cea552$exports = {
    "clear": `Izbri\u{161}i`,
    "invalid": `(neva\u{17E}e\u{107}e)`,
    "loading": `U\u{10D}itavam...`,
    "noResults": `Nema rezultata`
};


export {$5d0ff97fe4cea552$exports as default};
//# sourceMappingURL=sr-SP.module.js.map
